<template>
    <v-container
        fluid
        fill-height
    >
        <v-row
            align="center"
            justify="center"
        >
            <v-col xs="12" sm="6" md="4">
                <v-card class="elevation-12">
                    <v-toolbar dark color="primary">
                        <v-toolbar-title>Регистрация</v-toolbar-title>
                    </v-toolbar>
                    <v-form @submit.prevent="$emit('submit')">
                        <v-card-text>
                            <v-text-field
                                :value="registration.first_name"
                                @input="$emit('update:first_name', $event)"
                                :error-messages="errorMessages.first_name"
                                prepend-icon="mdi-account"
                                name="name"
                                label="Имя"
                                type="text">
                            </v-text-field>
                            <v-select
                                :value="registration.country_id"
                                @input="$emit('update:country_id', $event)"
                                prepend-icon="mdi-flag"
                                :error-messages="errorMessages.country_id"
                                :items="countries"
                                :cache-items="true"
                                item-text="name_ru"
                                item-value="id"
                                label="Страна"
                            >
                            </v-select>
                            <v-text-field
                                :value="registration.email"
                                @input="$emit('update:email', $event)"
                                :error-messages="errorMessages.email"
                                prepend-icon="mdi-email"
                                name="email"
                                label="Почта"
                                type="email">
                            </v-text-field>
                            <v-text-field
                                :value="registration.password"
                                @input="$emit('update:password', $event)"
                                :error-messages="errorMessages.password"
                                prepend-icon="mdi-lock"
                                name="password"
                                label="Пароль"
                                type="password"
                            ></v-text-field>
                            <v-text-field
                                :value="registration.password_repeat"
                                @input="$emit('update:password_repeat', $event)"
                                :error-messages="errorMessages.password_repeat"
                                prepend-icon="mdi-lock"
                                name="password_repeat"
                                label="Пароль, повторно"
                                type="password"
                            ></v-text-field>
                            <v-alert
                                v-if="errorMessages.captcha.length > 0"
                                type="error"
                                dense
                                outlined
                            >
                                Ошибка проверки безопасности. Попробуйте отправить запрос повторно.
                            </v-alert>
                            <slot name="captcha" />
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                    :disabled="wait"
                                    :class="[{'js-sign-up-wait': wait}]"
                                    type="submit"
                                    color="primary"
                                >Отправить</v-btn>
                            </v-card-actions>
                        </v-card-text>
                        <v-divider></v-divider>
                        <v-card-actions>
                            <v-btn
                                text
                                small
                                to="/password"
                            >
                                Вспомнить пароль
                            </v-btn>
                            <v-spacer></v-spacer>
                            <v-btn
                                text
                                small
                                to="/sign-in"
                            >
                                Войти в личный кабинет
                            </v-btn>
                        </v-card-actions>
                    </v-form>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
export default {
    name: 'SignUpDefault',
    props: {
        registration: {
            type: Object,
            required: true,
        },
        errorMessages: {
            type: Object,
            required: true,
        },
        countries: {
            type: Array,
            required: true,
        },
        wait: {
            type: Boolean,
            default: false,
        },
    },
}
</script>
